export default __webpack_public_path__ + "static/media/03.ba256a20.png";